import { createContext, useContext, useState } from 'react';
import { defaultState } from './consts';
import { ShefDashboardContextType, ShefDashboardProviderProps } from './types';

const ShefDashboardContext = createContext<ShefDashboardContextType>(undefined);

const ShefDashboardProvider = ({ children }: ShefDashboardProviderProps) => {
  const [isNavigationOpen, setIsNavigationOpen] = useState<boolean>(false);
  const state = {
    navigation: {
      isOpen: isNavigationOpen,
      open: () => setIsNavigationOpen(true),
      close: () => setIsNavigationOpen(false),
      toggle: () => setIsNavigationOpen(!isNavigationOpen),
    },
  };

  return <ShefDashboardContext.Provider value={state}>{children}</ShefDashboardContext.Provider>;
};

const useShefDashboardContext = () => {
  const context = useContext(ShefDashboardContext);
  if (context === undefined) {
    return defaultState;
  }
  return context;
};

export { ShefDashboardProvider, useShefDashboardContext };
